import { render } from "./guvenli-cikis.vue?vue&type=template&id=70e35cc6"
import script from "./guvenli-cikis.vue?vue&type=script&lang=js"
export * from "./guvenli-cikis.vue?vue&type=script&lang=js"

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__